export const element = (label, name, icon, attract = false, params = {}) => ({ icon, label, attract, to: { name, params } });
